// extracted by css-extract-rspack-plugin
export default {"Header":"ExpressionWidgetHeader-module__Header___dtS7J","HeaderButton":"ExpressionWidgetHeader-module__HeaderButton___qU8Io"};